import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { initAmplitude } from "./analytics";

initAmplitude();

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <div>
        <Routes>
          <Route path="/:cohortId" element={<App />} />
          <Route path="/" element={<App />} />
        </Routes>
      </div>
    </Router>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
